import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {round, sumBy} from 'lodash';
import {EmiStatus} from '../model/emi-status';
import {PrepaymentStatus} from '../model/prepayment-status';
import {WriteOffService} from '../service/write-off.service';
import {Emi, EmiSchedule} from '../model/emi-schedule.model';
import {LendersInvested, Loan} from '../model/loan.model';
import {HttpClient} from '@angular/common/http';
import {LoanStatusType} from '../model/loan-status.model';
import {LoanSettlementService} from '../service/loan-settlement.service';
import {LoanRestructureService} from '../service/loan-restructure.service';
import {LoanRestructureStatus} from '../model/loan-restructure';
import {LoanDetailsService} from '../service/loan-details.service';
import {LoanUtil} from '../utils/loan.util';
import {EmiUtil} from '../utils/emi.util';
import moment = require('moment');
import { BrowserUtil } from '../utils/browser.util';

@Component({
    selector: 'app-loandetail',
    templateUrl: './loandetail.component.html',
    styleUrls: ['./loandetail.component.css'],
    providers: [ApiServiceService, WriteOffService, LoanSettlementService]
})
export class LoandetailComponent implements OnInit {
    loanId: string;
    loanAmount: number;
    investedAmount: number;
    roi: number;
    name: string;
    rating: string;
    portfolioName: string;
    portfolioId: string;
    contract: string;
    doc_length = false;
    fractionSize: any;
    generatedLoanId: string;
    repaidAmount = 0;
    hasUpcomingEmis: boolean;
    loanStatus: string;
    emiSchedule: EmiSchedule;
    lenderShare: number;
    prepaymentDetails: any;
    lendersInvested: LendersInvested[];
    loanSanctionStatus: LoanStatusType;
    loan: Loan;

    displayedColumns: any = ['due_on', 'payable_amount', 'remaining_tenure', 'emi_status'];
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @ViewChild(MatSort) sort: MatSort;
    dataSource: any;

    constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private ref: ApiServiceService,
                private storageService: StorageService, private loanDetailsService: LoanDetailsService, private emiUtil: EmiUtil,
                private  loanSettlementService: LoanSettlementService, private loanRestructureService: LoanRestructureService,private browserUtil: BrowserUtil) {
    }
    openFromMobile(e, download = false) {

        let webkit = this.browserUtil.nativeWindow.webkit;
        if (webkit) {
            e.preventDefault();
            e.stopPropagation();
            
            let url = e.target.href;
            if (!url) {
                url = e.target.parentNode.href;
            }
            var msg = JSON.stringify({ 'action': (download) ? 'download_file' : 'open_external', 'url': url });
            webkit.messageHandlers.cordova_iab.postMessage(msg);
        }
    }
    ngOnInit() {
        this.portfolioName = this.storageService.getItem(Keys.PORTFOLIO_NAME);
        this.portfolioId = this.storageService.getItem(Keys.PORTFOLIO_ID);
        this.loanId = this.route.snapshot.params['id'];
        this.http.post<any>(this.ref.baseURL() + 'getEmiDetailsLender',
            {
                loan_id: this.loanId,
                lender_id: this.storageService.getItem(Keys.LENDER_ID),
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                token: this.storageService.getItem(Keys.TOKEN)
            }).subscribe(async investmentDetails => {
            if (investmentDetails.status_code === 200) {
                this.investedAmount = investmentDetails.invested_amount;
                if (!this.isLoanClosed(this.loanStatus) && !this.isLoanReversed(this.investedAmount)) {
                    this.roi = investmentDetails.response.roi;
                    this.rating = investmentDetails.response.rating;
                    const loanAmount = investmentDetails.response.loan_amount;
                    this.lenderShare = this.investedAmount / loanAmount;
                    this.loanAmount = loanAmount === 0 ? '--' : loanAmount;
                    this.generatedLoanId = investmentDetails.response.generated_loan_id;
                    this.emiSchedule = investmentDetails.response.emi_schedule;
                    this.prepaymentDetails = investmentDetails.response.prepayment_details;
                    this.loanSanctionStatus = investmentDetails.response.loan_sanction_status;
                    const pendingEmis = this.formatEmisForLender(this.emiSchedule, this.lenderShare);
                    this.loan = (await this.loanDetailsService.getLoanDetails(this.loanId)).loan_info;
                    this.repaidAmount = await this.getRepaidAmount(investmentDetails.response.emi_delay_details, this.emiSchedule, this.prepaymentDetails, this.lenderShare, this.loan);
                    this.loanStatus = LoanUtil.getDisplayableLoanStatus(this.loan.loan_sanction_status, !!this.loan.loanRestructuredOn, investmentDetails.response.filled_percentage, );
                    this.lendersInvested = investmentDetails.response.lenders_invested;
                    this.hasUpcomingEmis = !!pendingEmis.length;

                    this.dataSource = new MatTableDataSource(pendingEmis);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;

                    this.initSignedDocuments(investmentDetails);
                }
            }
        });
    }

    goToBread() {
        this.router.navigate(['/portfoliodetail/' + this.portfolioId]);
    }

    async getRepaidAmount(emiDelayDetails: any, emiSchedule: EmiSchedule, prepaymentDetails: any, lenderShare: number, loan: Loan): Promise<number> {
        let principalEarnedFromSettlement = 0;
        let interestEarnedFromSettlement = 0;
        let penaltyEarnedFromSettlement = 0;
        const earnedFromEmis = emiSchedule
            .filter(emi => emi.status === EmiStatus.Completed)
            .reduce((totalReceived, completedEmi) => totalReceived + (completedEmi.emi_amount * lenderShare), 0);

        const earnedFromPrepayments = prepaymentDetails.details.filter(prepayment => {
            return this.isPrepaymentSuccessful(prepayment);
        }).reduce((totalReceived, successfulPrepayment) => {
            return totalReceived + (successfulPrepayment.prepayment_amount * lenderShare);
        }, 0);

        const penaltyAmount = this.getPenaltyAmount(emiDelayDetails.emi_delay, lenderShare);
        if (loan.loan_sanction_status === LoanStatusType.ClosedSettlement) {
            const loanSettlementDetails = await this.loanSettlementService.getByLoanId(loan._id);
            principalEarnedFromSettlement = sumBy(loanSettlementDetails, (settlement) => settlement.oneTimeSettlement.principal) * lenderShare;
            interestEarnedFromSettlement = sumBy(loanSettlementDetails, (settlement) => settlement.oneTimeSettlement.interestAccrued) * lenderShare;
            penaltyEarnedFromSettlement = sumBy(loanSettlementDetails, (settlement) => settlement.oneTimeSettlement.penalInterest) * lenderShare;
        }
        let fromRestructuring = 0;
        if (loan.loanRestructuredOn) {
            const loanRestructurings = await this.loanRestructureService.getByLoanIdAnsStatuses(loan._id, [LoanRestructureStatus.restructuringReceived, LoanRestructureStatus.complete]);
            fromRestructuring = loanRestructurings ? sumBy(loanRestructurings, (loanRestructuring) => loanRestructuring.upfrontPaymentTotal) * lenderShare : 0;
        }
        return round(earnedFromPrepayments + earnedFromEmis + penaltyAmount + principalEarnedFromSettlement + interestEarnedFromSettlement + penaltyEarnedFromSettlement + fromRestructuring, 2);
    }

    formatEmisForLender(emiSchedule: EmiSchedule, lenderShare: number): any {
        return emiSchedule.map(emi => {
                return {
                    'dueOn': emi.due_on,
                    'payableAmount': round((lenderShare * emi.emi_amount), 2),
                    'remainingTenure': emi.remaining_tenure,
                    'emiStatus': this.getPaymentStatus(emi)
                };
            });
    }

    getPenaltyAmount(emiDelays: any[], lenderShare: number) {
        let penalty = 0;
        emiDelays.forEach(delay => {
            if (delay.is_delay_amount_paid) {
                penalty += delay.penalty;
            }
        });
        return penalty * lenderShare;
    }

    isLoanClosed(loanStatus: string): boolean {
        return (loanStatus === 'loan_expired' || loanStatus === 'rejected' || loanStatus === 'closed');
    }

    getEmiScheduleLabel(): string {
        return this.loan.loanRestructuredOn ? 'Restructured EMI Schedule' : 'EMI Schedule';
    }

    private isLoanReversed(invested_amount: number): boolean {
        return invested_amount === 0;
    }

    private initSignedDocuments(investmentDetails) {
        const signedDocument = investmentDetails.response.signed_document;
        if (!signedDocument) {
            this.doc_length = false;
        } else {
            this.doc_length = true;
            for (let i = 0; i < signedDocument.length; i++) {
                if (investmentDetails.response.signed_document[i].type === 'contract') {
                    this.contract = investmentDetails.response.signed_document[i].source;
                }
            }
        }
    }

    private isPrepaymentSuccessful(prepayment) {
        return (prepayment.prepayment_status === PrepaymentStatus.PrepaymentCompleted) ||
            (prepayment.prepayment_status === PrepaymentStatus.PartpaymentCompleted);
    }

    private isWrittenOff(loanStatus: string): boolean {
        return (loanStatus === 'Sub Standard Asset' || loanStatus === 'Loss Asset');
    }

    private isSettledAndClosed(loanStatus: string): boolean {
        return loanStatus === 'Settled and Closed';
    }

    private getPaymentStatus(emi: Emi): string {
        if (this.emiUtil.isEmiPaid(emi)) {
            return 'Paid';
        } else if (moment(emi.due_on).isBefore(moment())) {
            return 'Unpaid';
        } else {
            return 'Upcoming';
        }
    }
}

